var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"toastRoot"}},[_c('div',{style:({'background':_vm.$store.state.baseColor}),attrs:{"id":"toastContainer"}},[_c('div',{attrs:{"id":"toastMessageTagParent"}},[_c('label',[_vm._v(_vm._s(_vm.$store.state.toastMessage))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04389e0c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/CPlan/Toast.vue
// module id = null
// module chunks = 